import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { extraSmallSwatchBorderWidth, extraSmallSwatchPadding, selectedSwatchBorderWidth, shapes, sizes, swatchDiameters, swatchPadding, } from './constants';
const selectedSwatchPadding = swatchPadding - selectedSwatchBorderWidth;
export const useSwatchStyles = ({ isDisabled, isLoading, isSelected, shape = 'CIRCLE', size = 'medium', }) => (useMemo(() => (css `
        ${styleUtils.borderBox}
        ${shape === shapes.CIRCLE && css `
          border-radius: 100%;
        `}
        cursor: pointer;
        display: block;
        height: ${styleUtils.rem(swatchDiameters[size])};
        padding-bottom: ${styleUtils.rem(swatchPadding)};
        padding-left: ${styleUtils.rem(swatchPadding)};
        padding-right: ${styleUtils.rem(swatchPadding)};
        padding-top: ${styleUtils.rem(swatchPadding)};
        width: ${styleUtils.rem(swatchDiameters[size])};
        ${isSelected && css `
          border-color: ${theme.colors.gray700};
          border-style: solid;
          border-width: ${styleUtils.rem(selectedSwatchBorderWidth)};
          padding-bottom: ${styleUtils.rem(selectedSwatchPadding)};
          padding-left: ${styleUtils.rem(selectedSwatchPadding)};
          padding-right: ${styleUtils.rem(selectedSwatchPadding)};
          padding-top: ${styleUtils.rem(selectedSwatchPadding)};
        `}
        ${size === sizes.xsmall && css `
          border-width: ${styleUtils.rem(extraSmallSwatchBorderWidth)};
          padding-bottom: ${styleUtils.rem(extraSmallSwatchPadding)};
          padding-left: ${styleUtils.rem(extraSmallSwatchPadding)};
          padding-right: ${styleUtils.rem(extraSmallSwatchPadding)};
          padding-top: ${styleUtils.rem(extraSmallSwatchPadding)};
        `}
        ${(isLoading || isDisabled) && css `
          border-color: ${theme.colors.gray400};
          cursor: default;
        `}
        ${!(isLoading || isDisabled) && !isSelected && css `
          &:hover {
            border-color: ${theme.colors.gray700};
            border-style: solid;
            border-width: ${styleUtils.rem(selectedSwatchBorderWidth)};
            padding-bottom: ${styleUtils.rem(selectedSwatchPadding)};
            padding-left: ${styleUtils.rem(selectedSwatchPadding)};
            padding-right: ${styleUtils.rem(selectedSwatchPadding)};
            padding-top: ${styleUtils.rem(selectedSwatchPadding)};
          }
        `}
      `), [
    isDisabled,
    isLoading,
    isSelected,
    shape,
    size,
]));
